import { createQueryKeys, inferQueryKeys } from '@lukemorales/query-key-factory';

import { $httpAtlas, $httpDeveloper, $httpLandlord, $httpRoot, useQuery, UseQueryOptions } from '@core/http-client';
import { ConfigAgency, ConfigAtlas, ConfigDeveloper, ConfigLandlord } from '@shared/models/config';

import { ConfigErrorResponse } from './configApi.types';

export const configQueryKeys = createQueryKeys('config', {
  all: null,
  showAgency: () => ({
    queryKey: [''],
    queryFn: async () => (await $httpRoot.get<ConfigAgency>(`/config`)).data,
  }),
  showAtlas: () => ({
    queryKey: [''],
    queryFn: async () => (await $httpAtlas.get<ConfigAtlas>(`/config`)).data,
  }),
  showDeveloper: () => ({
    queryKey: [''],
    queryFn: async () => (await $httpDeveloper.get<ConfigDeveloper>(`/config`)).data,
  }),
  showLandlord: () => ({
    queryKey: [''],
    queryFn: async () => (await $httpLandlord.get<ConfigLandlord>(`/config`)).data,
  }),
});
export type ConfigQueryKeys = inferQueryKeys<typeof configQueryKeys>;

export const useConfigAgencyFetchQuery = (options?: UseQueryOptions<ConfigAgency, ConfigErrorResponse>) =>
  useQuery<ConfigQueryKeys['showAgency']['queryKey'], ConfigAgency, ConfigErrorResponse>({
    ...configQueryKeys.showAgency(),
    keepPreviousData: true,
    ...options,
  });

export const useConfigAtlasFetchQuery = (options?: UseQueryOptions<ConfigAtlas, ConfigErrorResponse>) =>
  useQuery<ConfigQueryKeys['showAtlas']['queryKey'], ConfigAtlas, ConfigErrorResponse>({
    ...configQueryKeys.showAtlas(),
    keepPreviousData: true,
    ...options,
  });

export const useConfigDeveloperFetchQuery = (options?: UseQueryOptions<ConfigDeveloper, ConfigErrorResponse>) =>
  useQuery<ConfigQueryKeys['showDeveloper']['queryKey'], ConfigDeveloper, ConfigErrorResponse>({
    ...configQueryKeys.showDeveloper(),
    keepPreviousData: true,
    ...options,
  });

export const useConfigLandlordFetchQuery = (options?: UseQueryOptions<ConfigLandlord, ConfigErrorResponse>) =>
  useQuery<ConfigQueryKeys['showLandlord']['queryKey'], ConfigLandlord, ConfigErrorResponse>({
    ...configQueryKeys.showLandlord(),
    keepPreviousData: true,
    ...options,
  });
